/** @griffel:css-start [d] null **/
.fuzgk9b{min-inline-size:0;}
/** @griffel:css-end **/